import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/playbooks/my-steps')({
  beforeLoad: () => {
    throw redirect({ to: '/playbooks/tasks/mine' });
  },
});
